import React from 'react';

import { Link } from 'gatsby';
import styles from './forms.module.scss';

export const FormDataProtection = () => {
  return (
    <div>
      <div className={styles.dataProtectionDescription}>
        Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie in unserer{' '}
        <Link to="/datenschutzerklaerung" className={styles.dataProtectionLink}>
          Datenschutzerklärung
        </Link>
      </div>
    </div>
  );
};
